define('shared/initializer/form/newHouseAdapters/mixins/DefaultSettingsApplyable',[
    'shared/lib/RSVP',
    'shared/remote/settings/student/put',
    'shared/remote/member/studentType',
    'shared/util/padStart'
], 
function(
    RSVP,
    updateStudentSettings,
    studentType,
    padStart
){
    function Ctor() {}

    Ctor.prototype.doBeforeSubmit = function () {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                return studentType();
            })
            .then(function(studentType){
                me.studentTypeBeforeSubmit = studentType;
            });
    };

    Ctor.prototype.doBeforeRedirect = function(data) {
        var me = this;
        return RSVP.resolve()
            .then(function(){
                // only fire it for new user
                if (me.studentTypeBeforeSubmit !== 'NewStudent') {
                    return;
                }
                var now = new Date();
                var year = now.getUTCFullYear();
                var month = now.getUTCMonth() + 1;
                var date = now.getUTCDate();
                var hour = padStart(now.getUTCHours(), 2, '0');
                var min = padStart(now.getUTCMinutes(), 2, '0');
                var sec = padStart(now.getUTCSeconds(), 2, '0');
                var midayIndicator = hour > 11 ? 'PM': 'AM';
                var nowString = [month, date, year].join('/') + ' ' +
                    [hour % 12, min, sec].join(':') + ' ' + midayIndicator;

                return updateStudentSettings('school', [{
                    key: 'School.Courseware.MemberDateActivated',
                    value: nowString
                }, {
                    key: 'student.course.version',
                    value: 'course.version.dla_e17'
                }, {
                    key: 'student.platform.version',
                    value: '2.0'
                }, {
                    key: 'student.writing.version',
                    value: '2.0'
                }, {
                    key: 'student.leveltest.version',
                    value: '2.0'
                }, {
                    key: 'student.platform2.ge.version',
                    value: '2.0'
                }, {
                    key: 'student.platform2.be.version',
                    value: '2.0'
                }, {
                    key: 'student.platform.mapcode',
                    value: 'common'
                }, {
                    key: 'studyplan.newui.enabled',
                    value: 'true'
                }, {
                    key: 'abtesting_available_campus.plbooking.mvt',
                    value: 'newplbooking'
                }, {
                    key: 'StudyPlan.Version',
                    value: 'V4'
                }]);
            })
            .then(function(){
                return data;
            }, function(crap){
                // this default settings is not that essential
                // and it unstable at the moment so
                // just log it and let the user pass
                console.error(crap);
                return RSVP.resolve(data);
            });
    };

    return Ctor;
});
